module.exports = __webpack_public_path__ + "assets/img/8_1626.eddf4654.jpg";